<!-- Botón de apertura de ventana de preselección -->
<div
    class="live-help-button-wrapper"
    [class.hidden]="(showChatButton$ | async) === false"
    [class.is-rtl]="isRtl$ | async"
    [class.is-animated]="isAnimated$ | async"
    [class.is-light]="isLightTheme$ | async"
    [class.is-chat-button-centered]="isButtonCenteredByPage$ | async"
    [class.close-selection]="closeSelection"
    [class.open]="buttonStyles.open"
    [class.closed]="buttonStyles.closed"
    *ngIf="(chatVisible$ | async) && (useFloatingButton$ | async)"
    (click)="openSelection()"
>
    <svg-icon *ngIf="!closeSelection" src="chat"></svg-icon>
    <svg-icon *ngIf="closeSelection" class="is-invert" src="close"></svg-icon>
    <div class="chat-text text-m ttu">
        {{ 'dev.liveHelp.needHelp' | translate }}
    </div>
</div>

<!-- Bubble de chat si hay más bubbles configuradas -->
<div
    class="live-help-button-wrapper chat"
    [class.chat-animation-open]="closeSelection"
    [class.chat-animation-closed]="!closeSelection"
    (click)="openChat()"
>
    <svg-icon src="chat-text"></svg-icon>
</div>

<!-- Bubble de WhatsApp -->
<div
    class="live-help-button-wrapper whatsapp"
    [class.whatsapp-open]="closeSelection"
    [class.whatsapp-closed]="!closeSelection"
    *ngIf="(isWhatsApp$ | async) && (whatsAppConfig$ | async) as whatsAppConfig"
>
    <a
        [href]="whatsAppConfig.link"
        class="w-100 h-100 align-center"
        [class.link-inactive]="!whatsAppConfig.enabled"
        target="{{ isMobile ? '_self' : '_blank' }}"
        type="button"
    >
        <svg-icon src="whatsapp-green"></svg-icon>
    </a>
</div>

<!-- Ventana de preselección -->
<div class="live-help-window-wrapper text-center" *ngIf="(showLiveHelp$ | async) === true && (chatOpened$ | async)">
    <div class="header-icon" (click)="closeLiveHelpWindow()">
        <div class="ngdialog-close-chat">
            <svg-icon src="close"></svg-icon>
        </div>
    </div>

    <h5 class="text-l mb-8">{{ 'dev.liveHelp.needHelp' | translate }}</h5>

    <p class="text-l mb-32">{{ 'dev.liveHelp.selectOption' | translate }}</p>

    <!-- Hubtype -->
    <div class="help-box mb-16" (click)="openHubtype(hubTypeChat)" *ngIf="hubTypeChat$ | async as hubTypeChat">
        <div class="help-box-title mb-8">{{ 'dev.liveHelp.hubTypeChat' | translate }}</div>
        <p class="text-m">{{ 'dev.liveHelp.resolveQuestions' | translate }}</p>
    </div>

    <!-- Url Chat -->
    <div class="help-box mb-16" *ngIf="urlChat$ | async as urlChat" (click)="openUrlChat(urlChat)">
        <div class="help-box-title mb-8">{{ 'dev.liveHelp.urlChat' | translate }}</div>
        <p class="text-m">{{ 'dev.liveHelp.resolveQuestions' | translate }}</p>
    </div>

    <!-- Moca chat -->
    <div class="help-box mb-16" *ngIf="mochaChat$ | async as mochaChat" (click)="openMochaChat(mochaChat)">
        <div class="help-box-title mb-8">{{ 'dev.liveHelp.mocaChat' | translate }}</div>
        <p class="text-m">{{ 'dev.liveHelp.resolveQuestions' | translate }}</p>
    </div>

    <!-- Kakao Talk -->
    <kakao *ngIf="kakaoChat$ | async"></kakao>

    <!-- Style Advisor -->
    <div class="help-box" (click)="openStyleAdvisor()" *ngIf="styleAdvisor$ | async">
        <div class="help-box-title mb-8">{{ 'dev.liveHelp.styleAdvisor.title' | translate }}</div>
        <p class="text-m">{{ 'dev.liveHelp.styleAdvisor.description' | translate }}</p>
    </div>
</div>

<ng-container [ngSwitch]="activeChat$ | async">
    <!-- Style Advistor -->
    <style-advisor *ngSwitchCase="'STYLE_ADVISOR'" [hidden]="(chatOpened$ | async) === false"></style-advisor>

    <!-- Hubtype -->
    <hubtype *ngSwitchCase="'HUBTYPE'" [hidden]="(chatOpened$ | async) === false"></hubtype>

    <!-- Url Chat -->
    <url-chat *ngSwitchCase="'URLCHAT'" [hidden]="(chatOpened$ | async) === false"></url-chat>

    <mocha *ngSwitchCase="'MOCHACHAT'" [hidden]="(chatOpened$ | async) === false"></mocha>
</ng-container>
